export default __webpack_public_path__ + "static/media/resize-window.408026e2.svg";